import { render, staticRenderFns } from "./PhotosBoard.vue?vue&type=template&id=7d4ee226&scoped=true&"
import script from "./PhotosBoard.vue?vue&type=script&lang=js&"
export * from "./PhotosBoard.vue?vue&type=script&lang=js&"
import style0 from "./PhotosBoard.vue?vue&type=style&index=0&id=7d4ee226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ee226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4ee226')) {
      api.createRecord('7d4ee226', component.options)
    } else {
      api.reload('7d4ee226', component.options)
    }
    module.hot.accept("./PhotosBoard.vue?vue&type=template&id=7d4ee226&scoped=true&", function () {
      api.rerender('7d4ee226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analyzes/PhotosBoard.vue"
export default component.exports